import React from 'react';
import { LazyLoadingComponent } from '@niaratech/niara-react-components';
const loader = () => import('./index').then(r => r.default);
const LazyIndex = (props): JSX.Element => <LazyLoadingComponent loader={loader} {...props} />;
export default LazyIndex;